module.exports = __webpack_public_path__ + "static/media/popupSingle2.39ab212a.png";